function Termomechanika (){
    return(
        <div>
            termomechanika
        </div>
    );
};

export default Termomechanika;
